__turbopack_context__.v({
  "actionsWrp": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__actionsWrp",
  "appointment": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__appointment",
  "appointmentContainer": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__appointmentContainer",
  "bold": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__bold",
  "contactUs": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__contactUs",
  "copiedText": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__copiedText",
  "label": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__label",
  "mainTitle": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__mainTitle",
  "row": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__row",
  "subTitle": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__subTitle",
  "successContainer": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__successContainer",
  "title": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__title",
  "value": "scheduleDemoFormSuccess-module-scss-module__Tn8aRW__value",
});
